module.exports = __webpack_public_path__ + "img/edit.d48afa02.svg";